import React, { useState, useEffect } from 'react'
import { convertColors } from '../../functions/Functions';

function OtherLawyers() {
    const [promo_lawyers, setPromoLawyers] = useState(false);
    let lawyers_list = [];

    useEffect(() => {
        fetch('/api/promo_lawyers/').then(res => {
            if (res.ok) {
                res.json().then(
                    data => {
                        setPromoLawyers(data)
                    }
                )
            }
        })
    }, [])

    if(promo_lawyers) {
        promo_lawyers.forEach((lawyer, index) => {
            const {photo_url, name, city, title, company_name} = lawyer || ''
            const {name: title_name, color} = title || ''
            lawyers_list.push(
                <div className="promo-lawyer" key={index}>
                    <img src={photo_url} alt="" />
                    <div className="info">
                        <p id="title" style={{color: `${convertColors(color)}`}}>{title_name}</p>
                        <p id="name">{name}</p>
                        <p id="city">{city}</p>
                        <p id="company-name">{company_name}</p>

                    </div>
                </div>
            )
        })
    }

    if (promo_lawyers) {
        return (
            <div id="promo-lawyers">
                <h3>Dołącz do znakomitych prawników, którzy już korzystają z serwisu: </h3>
                <div className="promo-lawyers-content">
                    {lawyers_list}
                </div>
            </div>
        )
    }
}

export default OtherLawyers